module.exports = __webpack_public_path__ + "img/header.8b91c4f9.png";